export default __webpack_public_path__ + "0dfc9b2bc89be07333448cec4ea20966.svg";